import React, { useState } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  VStack,
} from '@chakra-ui/react'
interface AddIPModalProps {
  isOpen: boolean
  onClose: () => void;
 
  onSubmit: (data: { address: string; label?: string }) => void
}
export const AddIPModal = ({ isOpen, onClose, onSubmit}: AddIPModalProps) => {
  const [address, setAddress] = useState('')
  const [label, setLabel] = useState('')
  const [error, setError] = useState('')
  const validateIP = (ip: string) => {
    const regex =
      /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
    return regex.test(ip)
  }
  const handleSubmit = () => {
    if (!address) {
      setError('IP address is required')
      return
    }
    if (!validateIP(address)) {
      setError('Invalid IP address format')
      return
    }
    onSubmit({
      address,
      label: label || undefined,
    })
    setAddress('')
    setLabel('')
    setError('')
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent bg="gray.800" border="1px" borderColor="gray.700">
        <ModalHeader color="white">Add IP Address</ModalHeader>
        <ModalBody>
          <VStack spacing={4}>
            <FormControl isInvalid={!!error}>
              <FormLabel color="gray.300">IP Address</FormLabel>
              <Input
                value={address}
                onChange={(e) => {
                  setAddress(e.target.value)
                  setError('')
                }}
                placeholder="192.168.1.1"
                bg="gray.700"
                border="none"
                color="white"
                fontFamily="mono"
              />
              <FormErrorMessage>{error}</FormErrorMessage>
            </FormControl>
            <FormControl>
              <FormLabel color="gray.300">Label (Optional)</FormLabel>
              <Input
                value={label}
                onChange={(e) => setLabel(e.target.value)}
                placeholder="e.g. Office, Development Server"
                bg="gray.700"
                border="none"
                color="white"
              />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter gap={2}>
          <Button variant="ghost" onClick={onClose} color="gray.300">
            Cancel
          </Button>
          <Button
            bg="#ff3d00"
            color="white"
            onClick={handleSubmit}
            _hover={{
              bg: '#e53700',
              boxShadow: '0 0 20px rgba(255, 61, 0, 0.5)',
            }}
          >
            Add IP
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
